var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:('background: url(' + require('../assets/products/background-1.jpg') + ');     height: 250px;   background-position: center;\n'+
'    background-repeat: no-repeat;\n'+
'    background-size: cover;overflow: hidden')}),_c('product-detail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }